import { render } from "./PatientHistory.vue?vue&type=template&id=1a3e06aa&scoped=true&ts=true"
import script from "./PatientHistory.vue?vue&type=script&lang=ts"
export * from "./PatientHistory.vue?vue&type=script&lang=ts"

import "./PatientHistory.vue?vue&type=style&index=0&id=1a3e06aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3e06aa"]])

export default __exports__